<template>
  <div>
    <div class="p16">
      <div
        class="hide-shimmer-text shimmer-container rounded width100"
        :style="{ height: '50px' }"
      >
        random
      </div>
      <div
        class="hide-shimmer-text shimmer-container rounded width100 mt40"
        :style="{ height: '200px' }"
      >
        random
      </div>
      
      <div
        class="hide-shimmer-text shimmer-container rounded width100 mt40"
        :style="{ height: '100px' }"
      >
        random
      </div>
      <div
        class="hide-shimmer-text shimmer-container rounded width100 mt40"
        :style="{ height: '300px' }"
      >
        random
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderDetailsShimmer",
};
</script>
